import React, { useState } from 'react';
import { Input } from './input';
import { Label } from './label';

export const FloatingLabelInput = ({
    label,
    value,
    onChange,
    type = "text",
    bgColor = "bg-white",
    startIcon,
    endIcon,
    className = "",
    inputClassName = "",
    placeholder,
    ...props
}) => {
    const [isFocused, setIsFocused] = useState(false);
    const hasValue = value !== undefined && value !== null && value.toString().length > 0;
    const isActive = isFocused || hasValue;

    return (
        <div className={`relative ${className}`}>
            {startIcon && (
                <div className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 z-10 transition-colors duration-200">
                    {startIcon}
                </div>
            )}

            <Input
                type={type}
                value={value}
                onChange={onChange}
                onFocus={(e) => {
                    setIsFocused(true);
                    props.onFocus?.(e);
                }}
                onBlur={(e) => {
                    setIsFocused(false);
                    props.onBlur?.(e);
                }}
                className={`h-11 border-gray-200 focus:border-[#D4AF37] focus:ring-[#D4AF37]/20 rounded-xl transition-all 
          ${startIcon ? 'pl-10' : 'px-4'} 
          ${endIcon ? 'pr-10' : ''} 
          ${inputClassName}
        `}
                placeholder={isActive ? placeholder : " "}
                {...props}
            />

            <Label
                className={`absolute rounded-sm transition-all duration-200 pointer-events-none text-gray-500 truncate max-w-[90%]
          ${isActive
                        ? `-top-2 left-3 text-[10px] ${bgColor} px-1 text-[#D4AF37] font-bold z-10`
                        : `top-3 ${startIcon ? 'left-10' : 'left-4'} text-sm text-gray-400 z-0`
                    }`}
            >
                {label}
            </Label>

            {endIcon && (
                <div className="absolute right-3 top-1/2 -translate-y-1/2 z-20">
                    {endIcon}
                </div>
            )}
        </div>
    );
};
